import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import ProductTemplate from '../ProductTemplate'
import './index.scss'

/** 菜单主体内容  */
const MenuContent: FC = () => {
  return (
    <div className='menu-style-big-content-container'>
      <ProductTemplate />
    </div>
  )
}

export default observer(MenuContent)
